import { useAppSelector } from "../store/hooks";

/**
 * Hook that checks if service selection is required
 */
export const useServiceInitialization = () => {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const selectedService = useAppSelector((state) => state.service.selectedService);

  return {
    needsServiceSelection: isAuthenticated && !selectedService,
  };
};

export default useServiceInitialization;
